// vim: tabstop=8 softtabstop=0 noexpandtab shiftwidth=8 nosmarttab

export const ready = new Promise<void>((resolve) => {
	console.log(`document.readyState: ${document.readyState}`);
	if(document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', () => resolve());
	} else {
		resolve();
	}
});
